import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: true,
    ssidTipoProducto: 0,
    haIniciadoSesion: false,
    claveInstancia: sessionStorage.getItem("claveInstancia") || "",
    nombreSuscriptor: "",
    muestraBotonInicioSesion: true,
  },
  mutations: {
    setBotonInicioSesionVisible(state, muestraBotonInicioSesion)
    {
      state.muestraBotonInicioSesion = muestraBotonInicioSesion;
    },
    setHaIniciadoSesion(state, haIniciadoSesion)
    {
      state.haIniciadoSesion = haIniciadoSesion;
    },
    setClaveInstancia(state, claveInstancia)
    {
      state.claveInstancia = claveInstancia || "";

      if (state.claveInstancia) {
        sessionStorage.setItem("claveInstancia", state.claveInstancia);
      } else {
        sessionStorage.removeItem("claveInstancia");
      }
    },
    setNombreSuscriptor(state, nombreSuscriptor)
    {
      state.nombreSuscriptor = nombreSuscriptor;
      sessionStorage.nombreInstancia = nombreSuscriptor;
    },
    UPDATE_DRAWER_STATE(state, newDrawerState)
    {
      console.log(newDrawerState);
      state.drawer = newDrawerState;
    }
  },
  actions: {
  },
  modules: {
  }
})
